// extracted by mini-css-extract-plugin
module.exports = {"root":"Textual-module--root--2MpjK","title":"Textual-module--title--3YTU5","content":"Textual-module--content--3OeKy"};